import React, { useState } from "react";
import { ArrowRight } from "lucide-react";

const ContactForm = ({ para }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    designation: "",
    subject: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] =
    useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSubmitting) return;

    setIsSubmitting(true);

    const payload = {
      sheet: "thrive",
      name: formData.name,
      email: formData.email,
      company: formData.company,
      designation:
        formData.designation,
      subject: formData.subject,
      message: formData.message,
    };

    fetch(
      "https://zbpje4azgliercmqvfqkh34bqm0mlmwm.lambda-url.ap-south-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type":
            "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      .catch((error) => {
        console.error(
          "Error submitting form:",
          error
        );

        alert(
          "⚠️ Something went wrong. Please try again."
        );
      })
      .finally(() => {
        setIsSubmitting(false);

        alert(
          "✅ Form submitted successfully!"
        );

        setFormData({
          name: "",
          email: "",
          company: "",
          designation: "",
          subject: "",
          message: "",
        });
      });
  };

  return (
    <div className="w-full max-w-[950px] mx-auto">

      {/* TOP TEXT */}
      {para && (
        <p
          className="
            text-[#6D655F]
            text-[16px]
            md:text-[17px]
            leading-8
            text-center
            mb-10
            max-w-[720px]
            mx-auto
          "
        >
          {para}
        </p>
      )}

      {/* CARD */}
      <div
        className="
          relative
          overflow-hidden
          rounded-[38px]
          bg-white/70
          backdrop-blur-2xl
          border
          border-white/40
          shadow-[0_30px_80px_rgba(20,10,0,.06)]
          p-6
          md:p-10
        "
      >

        {/* GLOW */}
        <div
          className="
            absolute
            -top-24
            right-0
            w-72
            h-72
            bg-[#F3D7BD]/30
            blur-3xl
            rounded-full
          "
        />

        <form
          onSubmit={handleSubmit}
          className="relative z-10"
        >

          {/* ROW 1 */}
          <div className="grid md:grid-cols-2 gap-5 mb-5">

            <input
              type="text"
              name="name"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              required
              className="
                h-16
                px-6
                rounded-[22px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />

            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              className="
                h-16
                px-6
                rounded-[22px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />
          </div>

          {/* ROW 2 */}
          <div className="grid md:grid-cols-2 gap-5 mb-5">

            <input
              type="text"
              name="company"
              placeholder="Company Name"
              value={formData.company}
              onChange={handleChange}
              required
              className="
                h-16
                px-6
                rounded-[22px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />

            <input
              type="text"
              name="designation"
              placeholder="Designation"
              value={
                formData.designation
              }
              onChange={handleChange}
              required
              className="
                h-16
                px-6
                rounded-[22px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />
          </div>

          {/* SUBJECT */}
          <div className="mb-5">

            <input
              type="text"
              name="subject"
              placeholder="Subject"
              value={formData.subject}
              onChange={handleChange}
              required
              className="
                w-full
                h-16
                px-6
                rounded-[22px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />
          </div>

          {/* MESSAGE */}
          <div className="mb-7">

            <textarea
              name="message"
              rows="6"
              placeholder="Write your message..."
              value={formData.message}
              onChange={handleChange}
              required
              className="
                w-full
                p-6
                rounded-[28px]
                bg-[#FAF6F1]
                border
                border-[#EEE4D8]
                text-[#24160F]
                placeholder:text-[#9B928B]
                outline-none
                resize-none
                transition-all
                duration-300
                focus:border-[#D3B08B]
                focus:bg-white
                focus:shadow-[0_0_0_5px_rgba(243,215,189,.25)]
              "
            />
          </div>

          {/* BUTTON */}
          <button
            type="submit"
            disabled={isSubmitting}
            className="
              inline-flex
              items-center
              gap-3
              h-14
              px-8
              rounded-full
              bg-primary
              text-white
              font-medium
              transition-all
              duration-300
              hover:scale-[1.02]
              hover:bg-[#3A1E14]
              disabled:opacity-60
            "
          >
            {isSubmitting
              ? "Submitting..."
              : "Submit Inquiry"}

            {!isSubmitting && (
              <ArrowRight size={16} />
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;